import React from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';

import DateTimeDisplay from '../../../../../components/date-time-display';

function CapturedOnRenderer(props) {
  const { value } = props;
  if (!value || value.length === 0) {
    return null;
  }
  const interview = value[0];
  return (
    <a target="_blank" href={interview.overview_url}>
      <DateTimeDisplay value={interview.publish_date} format="short" /> <Fa name="external-link" />
    </a>
  );
}

CapturedOnRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    publish_date: PropTypes.string,
    overview_url: PropTypes.string,
  })),
};
CapturedOnRenderer.defaultProps = {
  value: null,
};

export default CapturedOnRenderer;
